const modalDelete = backdropRef => {
  backdropRef.innerHTML = '';
};

export default modalDelete;
